export default __webpack_public_path__ + "static/media/registerImage.717bbfe3.png";